import e from "sanitize-html";
const l = (a = "", t = {}) => e(a, {
  allowedAttributes: {
    "*": [
      "style",
      "class",
      "tabindex",
      "role",
      "aria-label"
    ],
    a: [
      "href",
      "target",
      "id",
      "data-on-click-link-name",
      "data-on-click"
    ]
  },
  ...t
});
export {
  l as s
};
